<template>
    <div :id="dialogId"
         class="modal fade"
         role="dialog"
         :aria-labelledby="`${dialogId}Title`"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered dialog-small"
             role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <label :id="`${dialogId}Title`"
                           class="modal-title">
                        <i class="icon icon-import" />
                        Load preset
                    </label>
                </div>
                <div class="modal-body">
                    <label>Select preset to load</label>
                    <div>
                        <select v-model="selectedPreset">
                            <option v-for="preset in presets"
                                    :key="`preset-${preset.id}`"
                                    :value="preset.id">
                                {{ preset.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer left-align">
                    <div class="ms-auto">
                        <button type="button"
                                class="btn btn-color btn-outline-primary btn-sm"
                                @click="cancelLoad">
                            Go Back
                        </button>
                        <update-button button-label="Load"
                                       :sending="sending"
                                       @click="loadConfirm" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { defineProps, defineEmits, defineExpose, onMounted, computed, ref } from 'vue';
    import axios from 'axios';
    import UpdateButton from '../UpdateButton.vue';
    import { modalDialog } from '../../js/ModalDialog.js';
    import { axiosError, axiosConfig } from '../../js/AjaxUtilities.js';

    const props = defineProps({
        modelValue: { // The preset id chosen
            type: Object,
            default: null
        },
        idNumber: { // number to make dialog unique
            type: Number,
            default: 0
        },
        type: { // type number. 0 = Recovery Goal, 1 = Relapse Prevention
            type: Number,
            default: 0
        }
    });

    defineExpose({
        show
    });

    const emit = defineEmits(['update:modelValue']);

    const selectedPreset = ref(0);
    const sending = ref(false);

    function show() {
        loadPresetsAndShow();
    }

    const dialogId = computed(() => `load-preset-dialog-${props.idNumber}`);

    const presets = ref([]);

    function cancelLoad() {
        modalDialog.closeModal(dialogId.value);
    }

    function loadConfirm() {
        modalDialog.closeModal(dialogId.value);
        emit("update:modelValue", selectedPreset.value);
    }

    function loadPresetsAndShow() {
        let type = props.type;

        axios
            .post(`/GoalPlan/LoadPresets`, type, axiosConfig())
            .then(function (response) {
                if (response.data.success) {
                    presets.value = response.data.presets;
                    showDialog();
                } else {
                    alert(`Failed to load presets: ${response.data.message}`);
                }
            })
            .catch(function (error) {
                axiosError("Load presets", axios, error);
            });
    }

    function showDialog() {
        modalDialog.openModal(dialogId.value);
    }


</script>
